export default __webpack_public_path__ + "static/media/origin-guarantee.11865e92.svg";